import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import GA4React from 'ga-4-react';
import { createBrowserHistory } from 'history';
import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import packageJSON from '../package.json';
import SkinRedux from './SkinRedux';
import Routes from './Routes';
import './Show.css';
import './Login.css';
import './Start.css';
import './AppFull.css';
import './App.css';

const { version, commit } = packageJSON;
const history = createBrowserHistory();

const userId = localStorage.getItem('userId') || Math.random();
localStorage.setItem('userId', userId);

let ga4react = null;

if (!GA4React.isInitialized()) {
  ga4react = new GA4React('G-T5CE4LGSJ6', {
    // debug_mode: process.node_evn !== 'production',
    user_id: userId,
    version: `${version}.${commit}`,
  });
  ga4react.initialize().then(() => {
    console.log('GA4 initialized');
  }).catch((err) => {
    console.log('GA4 failed to initialize', err);
  });
}

const trackEvent = (category,
  action,
  label) => {
  if (GA4React.isInitialized()) {
    ga4react.event(action, label, category);
  }
};

const onClick = (clickEvent) => {
  const target = clickEvent.target.closest('[aria-label]') || clickEvent.target.closest('[id]');
  const targetAd = clickEvent.target.closest('.adsbygoogle');
  if (target && (target.getAttribute('aria-label') || target.id)) {
    trackEvent({
      category: 'UI',
      action: 'click',
      label: target.getAttribute('aria-label') || target.id,
    });
  }
  if (targetAd) {
    trackEvent({
      category: 'UI',
      action: 'click',
      label: 'AD',
    });
  }
};

class App extends Component {
  componentDidMount() {
    if (GA4React.isInitialized() && ga4react) {
      ga4react.pageview(window.location.pathname);
    }
    history.listen((location) => {
      const { props } = this;
      const { hash } = location;
      if (hash && hash !== '') {
        setTimeout(
          () => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView();
            }
          },
          0,
        );
      }
      if (GA4React.isInitialized() && ga4react) {
        ga4react.pageview(window.location.pathname);
      }
      document.getElementById('root').scrollTop = 0;
      props.setQuery({
        offset: 0,
        limit: 10,
      });
      props.alertUser();
      props.hideMenu();
    });
    const clarityName = 'clarity';
    const tagName = 'script';
    const clarityId = '4cz9j8csav';
    window[clarityName] = window[clarityName] || function clarity(arg1, arg2, arg3) {
      (window[clarityName].q = window[clarityName].q || []).push([arg1, arg2, arg3]);
    };
    const tag = document.createElement(tagName);
    tag.async = 1;
    tag.src = `https://www.clarity.ms/tag/${clarityId}`;
    const [otherScriptTag] = document.getElementsByTagName(tagName);
    otherScriptTag.parentNode.insertBefore(tag, otherScriptTag);
  }

  render() {
    return (
      <Router history={history}>
        <SkinRedux onClick={onClick}>
          {Routes}
        </SkinRedux>
      </Router>
    );
  }
}

const
  mapStateToProps = (state) => ({
    address: state.geo.address,
    loadingStage: state.loadingStage,
    user: state.user,
  });

const
  mapDispatchToProps = (dispatch) => ({
    setQuery: (data) => {
      dispatch({
        type: 'SET_QUERY',
        query: data,
      });
    },
    alertUser: () => {
      dispatch({
        type: 'ALERT_USER',
        alert: false,
      });
    },
    hideMenu: () => {
      dispatch({
        type: 'SET_MENU',
        isOpen: false,
      });
    },
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);
